/** Namespace for the original body element sent alongside translated messages. */
export const ORIGINAL_BODY_NS = "urn:slickshift:original-body:0"
